const mixed =`<div align="center">
<a id="top "></a>
<h1>
    <img alt="MARKDOWN SYNTAX" src="https://cloud.githubusercontent.com/assets/5456665/13505154/0ca9ddf6-e1a2-11e5-9408-a8cfc6b493f0.png" width="350" height="70"></img>
</h1>


</div>

<br/><br/>

### HEADER

    # Header1
    ## Header2
    ### Header3
    #### Header4
    ##### Header5
    ###### Header6
    H1
    ===
    H2
    ---

# Header1
## Header2
### Header3
#### Header4
##### Header5
###### Header6
H1
===
H2
---

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### EMPHASIS

    *Italic1* _Italic2_
    **Bold1** __Bold2__
    ***Bold_Italic***
    ~~Strikethrough~~

*Italic1* _Italic2_ </br>
**Bold1** __Bold2__ </br>
***Bold_Italic*** </br>
~~Strikethrough~~

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### HORIZONTAL LINE

    ---
    ***
    ___

---
***
___

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### LIST

    unordered list:

    * item-1
      * sub-item-1
      * sub-item-2
    - item-2
      - sub-item-3
      - sub-item-4
    + item-3
      + sub-item-5
      + sub-item-6


    ordered list:

    1. item-1
     1. sub-item-1
     2. sub-item-2
    2. item-2
     1. sub-item-3
     2. sub-item-4
    3. item-3

unordered list:

* item-1
  * sub-item-1
  * sub-item-2
- item-2
  - sub-item-3
  - sub-item-4
+ item-3
  + sub-item-5
  + sub-item-6

ordered list:

1. item-1
 1. sub-item-1
 2. sub-item-2
2. item-2
 1. sub-item-3
 2. sub-item-4
3. item-3

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### TABLE

\`\`\`
Table Header-1 | Table Header-2 | Table Header-3
:--- | :---: | ---:
Table Data-1 | Table Data-2 | Table Data-3
TD-4 | Td-5 | TD-6
Table Data-7 | Table Data-8 | Table Data-9
\`\`\`

Table Header-1 | Table Header-2 | Table Header-3
:--- | :---: | ---:
Table Data-1 | Table Data-2 | Table Data-3
TD-4 | Td-5 | TD-6
Table Data-7 | Table Data-8 | Table Data-9

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### LINK

    https://github.com/MinhasKamal/github-markdown-syntax
    [GitHub](https://github.com/MinhasKamal/github-markdown-syntax)
    [click](https://github.com/MinhasKamal/github-markdown-syntax "GitHub Markdown Syntax")
    [README](/README.md)
    [Image](#image)

https://github.com/MinhasKamal/github-markdown-syntax
[GitHub](https://github.com/MinhasKamal/github-markdown-syntax)
[click](https://github.com/MinhasKamal/github-markdown-syntax "GitHub Markdown Syntax")
[README](/README.md)
[Image](#image)

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### IMAGE

    ![GitHub Logo](https://cloud.githubusercontent.com/assets/5456665/13322882/e74f6626-dc00-11e5-921d-f6d024a01eaa.png "GitHub")

![GitHub Logo](https://cloud.githubusercontent.com/assets/5456665/13322882/e74f6626-dc00-11e5-921d-f6d024a01eaa.png "GitHub")

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### QUOTE

    > Stay hungry; stay foolish.
    >> Quality is better than quantity.
    >>> Life is not fair; get used to it.

> Stay hungry; stay foolish.
>> Quality is better than quantity.
>>> Life is not fair; get used to it.

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### COMMENT

    [/]:# (This is a comment, you cannot see it)

[/]:# (This is a comment, you cannot see it)

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### CODE

    inline code- \`int i=0\`

    block code-
    \`\`\` C
    for(int i=0; i<10; i++){
        printf("Hallow World! \n");
    }
    \`\`\`

inline code- \`int i=0\`

block code-
\`\`\` C
for(int i=0; i<10; i++){
    printf("Hallow World! \n");
}
\`\`\`

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### GITHUB EMOJI

    :octocat: :rabbit: :alien: :+1: :bee: :bell: :ghost: :bulb: :imp:

:octocat: :rabbit: :alien: :+1: :bee: :bell: :ghost: :bulb: :imp:

[more...](https://github.com/scotch-io/All-Github-Emoji-Icons)

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### OTHERS

    Which one does @torvalds like most?
    - [ ] tiger \#
    - [ ] whale \*
    - [X] octocat \!


Which one does @torvalds like most?
- [ ] tiger \#
- [ ] whale \*
- [X] octocat \!

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### HTML TAGS

    <div align="center">
        <kbd>Markdown</kbd> also supports &#9608; <b>HTML</b> &#9608; <i>syntax</i> <!--invisible--> <br/>
        <a href="http://www.youtube.com/watch?feature=player_embedded&v=vq2jYFZVMDA" target="_blank">
            <img src="http://img.youtube.com/vi/vq2jYFZVMDA/0.jpg" alt="GitHub Video"
            border="10" width="460" height="250"/>
        </a>
    </div>

<div align="center">
    <kbd>Markdown</kbd> also supports &#9608; <b>HTML</b> &#9608; <i>syntax</i> <!--invisible--> <br/>
    <a href="http://www.youtube.com/watch?feature=player_embedded&v=vq2jYFZVMDA" target="_blank">
        <img src="http://img.youtube.com/vi/vq2jYFZVMDA/0.jpg" alt="GitHub Video"
        border="10" width="460" height="250"/>
    </a>
</div>

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

### TEXT ART

\`\`\`
root                         ┌───────────────────────┐             ┌──────────────┐
 ├─branch-1                  |        Vehicle        ├── has-a ───→|    Engine    |
 │  ├─sub-branch-1           └───────────────────────┘             └──────────────┘
 │  └─sub-branch-2                 ↑              ↑                      ↑   ↑                 top --\\
 ├─branch-2                        |              |                      |   |                 ┤ ^_^ |
 │  └─sub-branch-3                 |            is-a                     |   |                 └──-──┘
 │     ├─a                         |              |                      |   |
 │     └─b                         |         ┌────┴─────────┐            |   |
 ├─branch-3                       is-a       |    Toyota    ├── has-a ───┘   |                 top --\\
 │  └─sub-branch-4                 |         └──────────────┘                |                 ┤ @_@ |
 └─branch-4                        |                                       is-a                └──-──┘
    ├─sub-branch-5                 |                                         |
    ├─sub-branch-6           ┌─────┴──────────┐                     ┌────────┴────┐
    │  └─c                   │   Lamborghini  ├───────has-a ───────→│  V12 Engine │
    └─sub-branch-7           └────────────────┘                     └─────────────┘
\`\`\`

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>

#### References
- https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet
- https://daringfireball.net/projects/markdown/syntax
- http://learn.getgrav.org/content/markdown
- https://confluence.atlassian.com/bitbucketserver/markdown-syntax-guide-776639995.html

<br/>
<div align="right">
    <b><a href="#top ">↥ back to top</a></b>
</div>
<br/>
`
export {mixed}



// WEBPACK FOOTER //
// ./src/boilerplates/mixed.js